import { IconButton, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { BsChatDotsFill } from 'react-icons/bs'
import { useLocation } from 'react-router-dom'
import ChatDrawer from './ChatDrawer'

const HIDDEN_PATHS = ['/', '/ai-assistant']

const ChatFloatingButton: React.FC = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const location = useLocation()

  if (HIDDEN_PATHS.includes(location.pathname)) return null

  return (
    <>
      {!isOpen && (
        <IconButton
          aria-label="Open AI Chat"
          icon={<BsChatDotsFill size={22} />}
          onClick={onOpen}
          position="fixed"
          bottom="24px"
          right="24px"
          zIndex={1000}
          size="lg"
          colorScheme="brand"
          borderRadius="full"
          boxShadow="lg"
          _hover={{ transform: 'scale(1.05)', boxShadow: 'xl' }}
          transition="all 0.2s"
        />
      )}
      <ChatDrawer isOpen={isOpen} onClose={onClose} />
    </>
  )
}

export default ChatFloatingButton
